import { WsDeviceState } from "../models/WsDeviceState";

export const getDeviceStates = (response: any): any[] => {
    if (response?.attributes?.deviceStates) {
        return response?.attributes?.deviceStates;
    }

    return [];
}

export const getWsDevice = (deviceState: any): WsDeviceState => {
    let device: WsDeviceState = { 
        ipAddress: '', 
        fixedAddress: '', 
        serialAddress: '', 
        statusCode: 0, 
        codeActivity: 0,
        codeConnected: 0, 
        codeEnabled: 0,
        downloaderQueueCount: 0,
        uploaderQueueCount: 0,
        keyValues: [],
        peripheralAddresses: []
    };

    if (deviceState) {
        device.fixedAddress = deviceState.fixedAddress;
        device.ipAddress = extractIpAddress(deviceState.ipAddress);
        device.serialAddress = deviceState.serialAddress;

        if (deviceState?.state) {
            device.statusCode = Number(deviceState.state.statusCode);
            device.codeActivity = deviceState.state.codeActivity;
            device.codeConnected = deviceState.state.codeConnected;
            device.codeEnabled = deviceState.state.codeEnabled;
            device.downloaderQueueCount = deviceState.state.downloaderQueueCount;
            device.uploaderQueueCount = deviceState.state.uploaderQueueCount;
            device.keyValues = deviceState.state.keyValues;
            device.peripheralAddresses = deviceState.state.peripheralAddresses;
        }
    }

    return device;
}

const extractIpAddress = (value: string) => {
    let ipAddress = value;
    if (value) {
        ipAddress = value.includes(':') ? value.split(':')[0] : value; // Extract IP address if colon is present
    }
    return ipAddress;
}

export const getCommand = (response: any): string => {
    if (response?.command) {
        return response.command;
    }

    return '';
}
